import { render, staticRenderFns } from "./LahanUmumMonitoringPopulatePertama.vue?vue&type=template&id=38b9f8f5"
import script from "./LahanUmumMonitoringPopulatePertama.vue?vue&type=script&lang=js"
export * from "./LahanUmumMonitoringPopulatePertama.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports